<template>
  <CollectionForm is-edit />
</template>

<script>
import CollectionForm from '@/layouts/components/form/CollectionForm.vue'

export default {
  components: { CollectionForm },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
